class DetailsModal extends HTMLElement {
  constructor() {
    super();
    let lastScrollY = 0; // Global variable to store scroll position
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
  
    // Bind events
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
  
    // External trigger event listeners for desktop and tablet buttons
    const openModalButtonDesktop = document.getElementById('open-modal-btn-desktop');
    const openModalButtonTablet = document.getElementById('open-modal-btn-tablet');
  
    // Add event listeners for each button if they exist
    if (openModalButtonDesktop) {
      openModalButtonDesktop.addEventListener('click', this.open.bind(this));
    }
  
    if (openModalButtonTablet) {
      openModalButtonTablet.addEventListener('click', this.open.bind(this));
    }
  
    // Set role for summary toggle
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /*onBodyClick(event) {
      console.log("Body clicked", event.target);
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }*/

  open(event) {
    event.preventDefault();
    console.log("we clicked");
    document.querySelector('.container_head').style.zIndex = '10';
    /*this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);*/
    this.detailsContainer.setAttribute('open', true);
    /*document.body.addEventListener('click', this.onBodyClickEvent);*/
    document.body.classList.add('overflow-hidden');
    
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    console.log("we close?");
    
    // Save the current scroll position
    this.lastScrollY = window.scrollY;

    document.querySelector('.container_head').style.zIndex = '100';
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    
    this.detailsContainer.removeAttribute('open');

    // Optional: Remove the event listener if necessary
    // document.body.removeEventListener('click', this.onBodyClickEvent);
    
    // Restore scroll position after closing
    setTimeout(() => {
        window.scrollTo(0, this.lastScrollY); // Restore the scroll position
    }, 0); // Delay to ensure it runs after layout updates

    document.body.classList.remove('overflow-hidden');
  }

}

customElements.define('details-modal', DetailsModal);
